import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NotificationService, Notification } from '../../service/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.less'
})
export class NotificationsComponent implements OnInit {
  notificationService = inject(NotificationService);
  router = inject(Router);
  
  notifications: Notification[] = [];

  ngOnInit() {
    this.notificationService.loadNotifications();
    this.notificationService.getNotifications().subscribe(notifications => {
      this.notifications = notifications;
    });
  }

  getNotificationIcon(type: number): string {
    return this.notificationService.getNotificationIcon(type);
  }

  getNotificationColor(type: number): string {
    return this.notificationService.getNotificationColor(type);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }

  navigateToScript(scriptId: number | null) {
    if (scriptId) {
      this.router.navigate(['/scripts/submit', scriptId]);
    }
  }
}

